import bScroll from '@better-scroll/core';
import ObserveDOM from '@better-scroll/observe-dom';
bScroll.use(ObserveDOM);
export class NScroll {
  constructor({ dom, options, other = {} }) {
    this.normalScroll = null;
    this.dom = dom;
    this.options = options;
    this.other = other;
    this.initScroll();
  }
  initScroll() {
    if (this.normalScroll) {
      this.normalScroll.refresh();
      return;
    }
    const data = {
      scrollX: true,
      ...this.options,
    };
    this.normalScroll = new bScroll(this.dom, data);
    if (data.bounce) {
      this.normalScroll.on('beforeScrollStart', () => {
        this.normalScroll.options.bounceTime = 800;
      });
    }
    if (this.other.center) {
      this.scrollToCenter();
    }
  }
  scrollToCenter() {
    const x = this.normalScroll.maxScrollX / 2;
    this.normalScroll.scrollTo(x, 0, 0);
  }
  scrollToPostion(x) {
    this.normalScroll.scrollTo(-x, 0, 0);
  }
  destroyNormalScroll() {
    this.normalScroll && this.normalScroll.destroy();
    this.normalScroll = null;
  }
  clickPrev() {
    this.normalScroll.options.bounceTime = 0;
    this.normalScroll.scrollTo(this.normalScroll.x + 50, 0);
  }
  clickNext() {
    this.normalScroll.options.bounceTime = 0;
    this.normalScroll.scrollTo(this.normalScroll.x - 50, 0);
  }
}
